import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.85 9.48" fill="currentColor" {...this.props}><path d="M3.93 0L0 3.93l.78.78 2.59-2.6v7.37h1.11V2.11l2.59 2.6.78-.78L3.93 0z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/trend.inline.svg